module.exports = __webpack_public_path__ + "img/Assign.d0be8fc3.svg";